import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { axiosInstance } from "../../context/axiosInstance";
import { TrendingsPageV2 } from "./TrendingsPageV2";
import { TrendingProviderV2 } from "./components/chart/context/TrendingContextV2";

const TrendingsV2Index = () => {
	const [ihPathLoaded, setIhPathLoaded] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		const getIhPath = async () => {
			const resp = await axiosInstance.get("/backend/ih-path");
			localStorage.setItem("ihPath", resp.data);
			setIhPathLoaded(true);
		};
		getIhPath();
	}, []);

	if (!ihPathLoaded) {
		return (
			<div className={"d-flex justify-content-center align-items-center"}>
				Loading...
			</div>
		);
	}

	return (
		<TrendingProviderV2 key={location.key}>
			<TrendingsPageV2 />
		</TrendingProviderV2>
	);
};

export default TrendingsV2Index;
